import { MenuItem, TextField } from "@mui/material"
import { translate } from "app/language/service"
import { SELECT_FILTER_VALUES } from "form/model"
import React from "react"

interface ISelectionFilterProps {
  value: SELECT_FILTER_VALUES
  id?: string
  sx?: any
  allLabel?: string
  selectedLabel?: string
  notSelectedLabel?: string
  onChange(newValue: SELECT_FILTER_VALUES): any
}

export const SelectionFilter = React.memo(
  ({ value, id, sx, allLabel, selectedLabel, notSelectedLabel, onChange }: ISelectionFilterProps): JSX.Element => (
    <TextField
      id={id}
      variant="outlined"
      select
      size="small"
      sx={{ minWidth: "14rem", ...sx }}
      label={translate("label.select.filter.title")}
      value={value}
      onChange={event => onChange(event.target.value as SELECT_FILTER_VALUES)}>
      <MenuItem id={id ? `${id}-option-0` : undefined} value={SELECT_FILTER_VALUES.ALL}>
        {allLabel ? allLabel : translate("label.select.filter.all")}
      </MenuItem>
      <MenuItem id={id ? `${id}-option-1` : undefined} value={SELECT_FILTER_VALUES.SELECTED}>
        {selectedLabel ? selectedLabel : translate("label.select.filter.selected")}
      </MenuItem>
      <MenuItem id={id ? `${id}-option-2` : undefined} value={SELECT_FILTER_VALUES.NOT_SELECTED}>
        {notSelectedLabel ? notSelectedLabel : translate("label.select.filter.not-selected")}
      </MenuItem>
    </TextField>
  )
)
